import {scroller} from 'react-scroll';

import 'client/common/utils/request-idle-callback';

export function scrollToElement(element: HTMLElement) {
    window.requestIdleCallback(() => {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    });
}

export function scrollToClassName(className: string) {
    scroller.scrollTo(className, {
        duration: 500,
        smooth: true,
        offset: 0
    });
}
